import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import PageHero from "../ones/PageHero"; 
import FaqsHeroBg from '../assets/banner8.png'; // Badala ya picha ya asili ya background
import FaqsContent from "../ones/FaqsContent"
import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import CustomersBanner from "../ones/CustomersBanner";
import PageWithSidebar from "../components/PageWithSidebar";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [ ])

  if(ready) {
    return (
      <>
      <PageHero 
          bgImage={FaqsHeroBg}
          kicker="FAQS"
          heading="Maswali na Majibu (FAQs)"
          paragraph="Kila unachopenda kufahamu kuhusu huduma na mikopo ya YCSC SACCOS"
        />
        <PageWithSidebar>
          <FaqsContent/>
        </PageWithSidebar>
        <Footer/>
      </>
    )
  } else {
    return (
      <div 
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }

  
}
